import matchesResponsiveToken from './matches-responsive-token';

const getPatchedResponsiveClass = ({ currentClass = '', className, value, breakpoint }) => {
  let tokenBase;
  if (value === null) {
    tokenBase = className;
  } else if (value.includes('[')) {
    tokenBase = `${className}-${value}`;
  } else {
    tokenBase = `${className}-[${value}]`;
  }

  const newToken = breakpoint ? `${breakpoint}:${tokenBase}` : tokenBase;

  const filtered = currentClass
    .split(' ')
    .filter((cls) => cls && !matchesResponsiveToken(cls, className, breakpoint));

  filtered.push(newToken);
  return filtered.join(' ');
};

export default getPatchedResponsiveClass;
